export interface DealProps {
  commissionPoints: number;
  commission: number;
  loanAmount: number;
  originationFee: number;
  disbursementAmount: number;
  totalAmountPaidBack: number;
  term: number;
  paymentFrequency: string;
  apr: number;
  centsOnDollar: number;
  payment: number;
  numberOfPayments: number;
  offerId: string;
  prepaymentDiscountPercentage: number;
}

export const dealInitState: DealProps = {
  commissionPoints: 0,
  commission: 0,
  offerId: '',
  loanAmount: 0,
  originationFee: 0,
  disbursementAmount: 0,
  totalAmountPaidBack: 0,
  term: 0,
  paymentFrequency: 'Weekly',
  apr: 0,
  centsOnDollar: 0,
  payment: 0,
  numberOfPayments: 0,
  prepaymentDiscountPercentage: 0
};

export interface AccountManagerDetails {
  name: string;
  phone: string;
  email: string;
  applicationNumber: string;
}

export const accountManagerDetailsInitState: AccountManagerDetails = {
  name: '',
  phone: '',
  email: '',
  applicationNumber: ''
};

export interface Terms {
  offerId: string;
  term: number;
  lineAmount: number;
  buyRate: number;
  sellRate: number;
  paymentFrequency: string[];
  centsOnDollar: number;
  prepaymentDiscountPercentage: number;
}

export interface TermDetail {
  maxLineAmount: number;
  terms: Terms[];
}

export const termInitState: TermDetail = {
  maxLineAmount: 0,
  terms: []
};

export interface CustomerData {
  businessCountry: string;
  businessState: string;
  legalEntity: string;
  partner: string;
  partnerId: string;
  companyName: string;
  doingBusinessAs: string;
  selfReportedAnnualRevenue: number;
  email: string;
  industry: string;
  estimatedAnnualRevenue: number;
  onlineCheckoutEligible: boolean;
}

export const customerDataInitState: CustomerData = {
  businessCountry: '',
  businessState: '',
  legalEntity: '',
  partner: '',
  partnerId: '',
  companyName: '',
  doingBusinessAs: '',
  selfReportedAnnualRevenue: 0,
  email: '',
  industry: '',
  estimatedAnnualRevenue: 0,
  onlineCheckoutEligible: true
};

export interface LoanSpecifics {
  collectionType: string;
  line: number;
  paymentFrequency: string;
  productType: string;
  requestedCommission: number;
  term: number;
  centsOnDollar: number;
}

export const loanSpecificsInitState = {
  collectionType: '',
  line: 0,
  paymentFrequency: '',
  productType: '',
  requestedCommission: 0,
  term: 0,
  centsOnDollar: 0
};

export interface OfferResponse {
  offerId: string;
  applicationType: string;
  loanSpecifics: LoanSpecifics[];
  customerData: Object;
}

export const offerResponseInitState = {
  offerId: '',
  applicationType: '',
  loanSpecifics: [loanSpecificsInitState],
  customerData: customerDataInitState
};

export interface LineOfCreditOffer {
  apr: number;
  averageWeeklyPayment: number;
  buyRate: number;
  collectionType: string;
  equivalentCoD: number;
  lineAmount: number;
  numberOfPayments: number;
  offerId: string;
  paymentFrequency: Array<string>;
  sellRate: number;
  term: number;
  totalAmountPaidBack: number;
  totalDrawCost: number;
  weeklyPaymentEligible: boolean;
  disbursementAmount: number;
  lender: string;
  averageMonthlyPayment: number;
  payment: number;
  originationFee: number;
  totalInterest: number;
  trueAIR: number;
}

export const lineOfCreditInitState: LineOfCreditOffer = {
  apr: 0,
  averageWeeklyPayment: 0,
  buyRate: 0,
  collectionType: '',
  equivalentCoD: 0,
  lineAmount: 0,
  numberOfPayments: 0,
  offerId: '',
  paymentFrequency: [],
  sellRate: 0,
  term: 0,
  totalAmountPaidBack: 0,
  totalDrawCost: 0,
  weeklyPaymentEligible: false,
  disbursementAmount: 0,
  lender: '',
  averageMonthlyPayment: 0,
  payment: 0,
  originationFee: 0,
  totalInterest: 0,
  trueAIR: 0
};

export const enum ModalType {
  LOC = 'LOC',
  TL = 'TermLoan'
}

export interface OfferDetail {
  offer: TermDetail;
  applicationType: string;
  customerData: CustomerData;
  accountManagerDetails: AccountManagerDetails;
  lineOfCreditOffer: LineOfCreditOffer;
  selectedOffer: DealProps;
}

export const offerDetailInitState = {
  offer: termInitState,
  applicationType: 'NEW',
  customerData: customerDataInitState,
  accountManagerDetails: accountManagerDetailsInitState,
  lineOfCreditOffer: lineOfCreditInitState,
  selectedOffer: dealInitState
};

export interface DocDetail {
  id: String,
  merchantRequest: String,
  details: String,
  status: String,
  rejectionReason: String
}

export const docDetailInitState: DocDetail = {
  id: '',
  merchantRequest: '',
  details: '',
  status: '',
  rejectionReason: ''
};